import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import api from '@/api';
export default {
  data() {
    return {
      examList: [],
      // session.setStatus("TESTING");     // 开始考试时设置
      // session.setStatus("COMPLETED");   // 考试完成时设置
      // NOT_STARTED 表示没有session  相当于还没有进入考试
      examStatusMap: {
        NOT_STARTED: {
          label: '未完成',
          tagType: 'success'
        },
        COMPLETED: {
          label: '已完成',
          tagType: 'warning'
        },
        examResult: {}
      },
      dialogVisible: false,
      rankInfo: {}
    };
  },
  methods: {
    getExamStatuLabel(state) {
      if (state === 'COMPLETED') {
        return '已完成';
      }
      return '未完成';
    },
    getExamStatuTag(state) {
      if (state === 'COMPLETED') {
        return 'success';
      }
      return 'warning';
    },
    async getExamList() {
      const res = await api.getUserExamList();
      this.examList = res;
    },
    async goToExam(examPlanId, paperType) {
      this.$router.push({
        name: 'MockExamView',
        params: {
          paperType,
          examPlanId
          // subject,
        }
      });
    },
    async goToResult(examPlanId) {
      const res = await api.getExamRank({
        examPlanId
      });
      console.log(res, 'res');
      this.rankInfo.initial = res.list[0].initial;
      this.rankInfo.retake = res.list[0].retake;
      this.examResult = await api.getMockExamResult({
        examPlanId
      });
      this.examResult.initialUnits = this.examResult.initialUnits.map(item => {
        return {
          ...item,
          notDo: item.questionCount - item.rightAnswers - item.wrongAnswers,
          accuracy: (item.rightAnswers + item.wrongAnswers > 0 ? item.rightAnswers / (item.rightAnswers + item.wrongAnswers) : 0) * 100 + '%'
        };
      });
      this.examResult.retakeUnits = this.examResult.retakeUnits.map(item => {
        return {
          ...item,
          notDo: item.questionCount - item.rightAnswers - item.wrongAnswers,
          accuracy: (item.rightAnswers + item.wrongAnswers > 0 ? item.rightAnswers / (item.rightAnswers + item.wrongAnswers) : 0) * 100 + '%'
        };
      });
      this.dialogVisible = true;
      console.log(this.dialogVisible, this.examResult, 'res====');
    }
  },
  beforeMount() {
    this.getExamList();
  }
};